import { app } from '@/bootloader';
import '@quasar/extras/material-icons/material-icons.css';
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';;

// To be used on app.use(Quasar, { ... })
const quasarUserOptions = {
  supportTS: true,

  config: {
    brand: {
      primary: '#00D2A2',
      dark: '#4D4D4F',
      secondary: '#F0F3F4',
      negative: '#E12828',
    },
  },
  plugins: {
    Notify,
  },
};

app.use(Quasar, quasarUserOptions);
